import classNames from 'classnames';
import { useEffect, useState } from 'react';

import Anchor from '~components/Anchor/Anchor';
import { useAppSelector } from '~hooks/useRedux';

const DynamicContentAnchor = ({
    children,
    className = '',
    ...rest
}: React.PropsWithChildren<{ className: string; href?: string }>) => {
    const allid = useAppSelector((state) => state.global.allianceId);

    const [dynamicHref, setDynamicHref] = useState(rest.href);

    useEffect(() => {
        setDynamicHref(rest.href?.replaceAll('{{ALLIANCE_ID}}', allid));
    }, [allid]);

    return (
        <Anchor {...rest} className={classNames(className)} href={dynamicHref}>
            {children}
        </Anchor>
    );
};

export default DynamicContentAnchor;
